import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  avatarGroup: {
    '&.MuiAvatarGroup-root': {
      '& .MuiAvatar-root': {
        border: `1px solid ${theme.primary.p2}`,
      },
    },
  },
}));

export default useStyles;
